import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase configuration for 'mythic-maps'
const firebaseConfig = {
    apiKey: "AIzaSyDnpgYQge6knOtI5XqRrbGL-O1nqOk2z5I",
    authDomain: "mythic-maps.firebaseapp.com",
    projectId: "mythic-maps",
    storageBucket: "mythic-maps.firebasestorage.app", // Corrected based on gsutil ls output
    messagingSenderId: "332511586189",
    appId: "1:332511586189:web:b363971e9a215acc747fc4",
    measurementId: "G-MYSQEGSF8J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Connect to Functions emulator only if running locally (development) and not explicitly using prod backend
if (process.env.NODE_ENV === 'development' && 
    window.location.hostname === "localhost" && 
    process.env.REACT_APP_USE_PROD_BACKEND !== 'true') {
    console.log("Connecting to Firebase Functions Emulator...");
    try {
        // Only connect Functions to emulator, everything else uses production
        import("firebase/functions").then(({ connectFunctionsEmulator }) => {
            connectFunctionsEmulator(functions, "localhost", 5001);
            console.log("Connected to Functions emulator at localhost:5001");
        });
    } catch (error) {
        console.error("Error setting up Functions emulator connection:", error);
    }
} else if (process.env.REACT_APP_USE_PROD_BACKEND === 'true') {
    console.log("Using Firebase Production Backend (Functions)");
}

// Export services for use in other parts of your React app
export { app, auth, db, storage, functions }; 